var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-submit",class:_vm.customClasses,attrs:{"type":"submit","value":"Submit"}},[(_vm.icon)?_c('BaseIcon',{attrs:{"type":_vm.icon}}):_vm._e(),_c('span',[_vm._t("default",function(){return [_vm._v("Test")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }